import React from 'react';
import { SkeletonPanel, SkeletonText, SkeletonPage, SkeletonBox } from '../../components';



export const FulfillSellerOrderLoader: React.FC = () => {
  return (
    <SkeletonPage
      title="Order"
      subtitle={true}
      actions={true}
      breadcrumbs={true}
      loading={true}
    >
      <div className="flex flex-wrap items-start justify-center gap-5">
        <div className="min-w-[51%] flex-[2_2_30rem] space-y-5">
          <SkeletonPanel>
            <SkeletonPanel.Section>
              <SkeletonText lines={1} width={100} />
              <SkeletonBox height={25} />
              <div className="mt-4">
              <SkeletonBox height={240} />
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
          <SkeletonPanel title={true}>
            <SkeletonPanel.Section>
              <div className="grid grid-cols-4 gap-6">
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                  <SkeletonBox height={25} />
                </div>
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                  <SkeletonBox height={25} />
                </div>
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
          <SkeletonPanel title={true}>
            <SkeletonPanel.Section>
              <div className="grid grid-cols-4 gap-6">
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                  <SkeletonBox height={25} />
                </div>
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                  <SkeletonBox height={25} />
                </div>
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                </div>
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
          <SkeletonPanel title={true}>
            <SkeletonPanel.Section>
              <div className="grid grid-cols-4 gap-6">
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                </div>
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
        </div>
        <div className="min-w-0 flex-[1_1_15rem] space-y-5">
          <SkeletonPanel>
            <SkeletonPanel.Section title={true}>
              <SkeletonText lines={3} />
              <div className="flex justify-end mt-6 space-x-4">
                <SkeletonBox height={25} width={100} />
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
          <SkeletonPanel>
            <SkeletonPanel.Section title={true}>
              <SkeletonText lines={2} />
              <SkeletonBox height={80} />
            </SkeletonPanel.Section>
            <SkeletonPanel.Section subdued>
              <SkeletonText lines={1} variant='heading' width={100} />
            </SkeletonPanel.Section>
          </SkeletonPanel>
        </div>
      </div>
    </SkeletonPage>
  );
};
